<template>
    <div class="page page--center">
        <Header logo-size="xl" />
        <main class="page__main">
            <div class="content">
                <div class="content__body">
                    <div class="card border-light rounded-3 shadow-lg">
                        <div class="card-body">
                            <h2 class="card-title h4 mb-4 text-primary text-center text-md-start">Modification de l'e-mail</h2>

                            <div
                                :class="'alert' + (alert ? ' alert-' + alert.class : '') + ' text-center p-1 mt-2 fs-n1' + (!alert ? ' invisible' : '')"
                                role="alert"
                                v-html="alert ? alert.message : '&nbsp;'"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <Footer />
    </div>
</template>

<script>
import { mapActions } from 'vuex'

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Email',
    components: {
        Header,
        Footer,
    },
    data: () => ({
        alert: null,
    }),
    methods: {
        ...mapActions(['confirmNewEmail']),
    },
    async mounted() {
        this.alert = await this.confirmNewEmail({ token: this.$route.params.token })
    },
}
</script>
